// removed by extract-text-webpack-plugin
module.exports = {"header":"index_2xBQNQE"};


//////////////////
// WEBPACK FOOTER
// ./src/component/header/index.css
// module id = 903
// module chunks = 0